module.exports = __webpack_public_path__ + "img/circled-employee.8196ac00.png";